import React from "react"
import PropTypes from "prop-types"
import ClassNames from "classnames"
import Moment from "moment"
import DateTimePickerRW from "react-widgets/lib/DateTimePicker"
import createReactClass from "create-react-class"
import momentLocalizer from "react-widgets-moment"

import Styles from "../datepicker.less"
import ValidationMixin from "@cirrus/legacy/app-components/validations/validation-mixin/index.jsx"

var itemComp = createReactClass({
  render: function () {
    return <div>{this.props.item.label}</div>
  },
})

momentLocalizer()
var defaultValue = null
var DateTimePicker = createReactClass({
  propTypes: {
    value: PropTypes.any,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    tabIndex: PropTypes.number,
    autoFocus: PropTypes.bool,
    placeholder: PropTypes.string,
    format: PropTypes.string,
    editFormat: PropTypes.string,
    min: PropTypes.any,
    max: PropTypes.any,
    onChange: PropTypes.func,
    isNotValid: PropTypes.bool,
    "data-qa": PropTypes.string,
  },
  getDefaultProps: function () {
    var defaultFormat =
      Moment.localeData("en-GB")._longDateFormat.L +
      " " +
      Moment.localeData("en-GB")._longDateFormat.LT
    return {
      format: defaultFormat,
      editFormat: defaultFormat,
    }
  },
  getDefaultValue() {
    return defaultValue ? defaultValue : this.props.value
  },
  getClass() {
    return ClassNames(
      Styles.datePicker,
      {
        disabled: this.props.disabled,
      },
      this.props.className,
    )
  },
  getTimeComponent() {
    return itemComp
  },
  getTimeZoneOffset() {
    let { timeZone } = this.props

    if (timeZone == null) return 0

    let localOffset = Moment().utcOffset() * 60
    let zoneOffset = timeZone ? Moment.tz(timeZone).utcOffset() * 60 : localOffset
    let totalOffset = zoneOffset - localOffset

    return totalOffset
  },
  convertDate(date) {
    if (date == null) return date

    const offset = this.getTimeZoneOffset()
    if (offset == 0) return date

    let seconds = Moment.utc(date).unix()
    let converted = (seconds + offset) * 1000

    return Moment(converted).toDate()
  },
  revertDate(date) {
    if (date == null) return date

    const offset = this.getTimeZoneOffset()
    if (offset == 0) return date

    let seconds = Moment.utc(date).unix()
    let converted = (seconds - offset) * 1000

    return Moment(converted).toDate()
  },
  handleChange(value) {
    const { onChange } = this.props

    onChange && onChange(this.revertDate(value))
  },
  render() {
    const { value, defaultCurrentDate = new Date(), min, max } = this.props

    const convertedValue = this.convertDate(value)
    const convertedDefaultCurrentDate = this.convertDate(defaultCurrentDate)
    const convertedMin = this.convertDate(min)
    const convertedMax = this.convertDate(max)

    return (
      <DateTimePickerRW
        value={convertedValue}
        className={this.getClass()}
        defaultValue={this.getDefaultValue()}
        disabled={this.props.disabled}
        placeholder={this.props.placeholder}
        tabIndex={this.props.tabIndex}
        autoFocus={this.props.autoFocus}
        onChange={this.handleChange}
        format={this.props.format}
        editFormat={this.props.editFormat}
        min={convertedMin}
        max={convertedMax}
        defaultCurrentDate={convertedDefaultCurrentDate}
        timeComponent={this.getTimeComponent()}
        data-qa={this.props["data-qa"]}
      />
    )
  },
})

export default ValidationMixin(DateTimePicker)
